export default "__VITE_ASSET__CExWcqyp__"